import Immutable from "immutable";
import { Client } from "resourceModels";

export default class ChatPlatformRecord extends Immutable.Record({
  name: "chat",
  fullName: "Chat",
  rollout: 1.0,
  enabled: true,
  showLogo: false,
  privacy: false,
  privacyLink: "",
  persistence: "normal",
  timeToExpiry: 0,
  expiryTime: "",
  expiryUnitOfTime: "mins",
  buttonCarousel: "none",
  buttonLayoutMobile: "carousel",
  buttonLayoutDesktop: "stacked",

  isVisibleToClient(client: Client): boolean {
    return (
      client.hasFullSitePrivileges &&
      !client.features.get("zendeskClient")
    );
  }
}) {}
